const NO_PROJECT_CODE = "000";

const FIN_JOB_TYPE_NO_PROJECT = "-1";
const FIN_JOB_TYPE_PROJECT = "Проект";

const normalizeText = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export const isNoProject = (project) => {
  if (!project) return false;
  const projectName = normalizeText(project.name);
  return (
    project.cipher_pilot === NO_PROJECT_CODE ||
    projectName.includes("000_без проекта") ||
    projectName.includes("000-без проекта") ||
    projectName.includes("без проекта")
  );
};

export const getFinJobTypeForProject = (project) =>
  isNoProject(project) ? FIN_JOB_TYPE_NO_PROJECT : FIN_JOB_TYPE_PROJECT;

export const filterWorkTypesByFinProject = (workTypes, project) => {
  if (!Array.isArray(workTypes)) return [];
  const finJobType = getFinJobTypeForProject(project);
  return workTypes.filter(
    (workType) => workType?.type_of_fin_job_type === finJobType,
  );
};
